import axios from '@/axios-service';
import { ResponseContent, responseContent } from '../types';
import { AvailabilityDTO } from './types';

const MS_URL = 'senana/api/products/v1';
const asAvailabilityDTO = responseContent(AvailabilityDTO);

export const getProducts = async (): Promise<ResponseContent<AvailabilityDTO[]>> => axios
  .get(MS_URL)
  .then(asAvailabilityDTO);
